import {TagDefinitionSelectorProps, tagDefinitionsSelector, useGetAllTagDefinitionsQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseTagDefinitionMultiSelect, BaseTagDefinitionMultiSelectProps} from "./BaseTagDefinitionMultiSelect";

export type TagDefinitionMultiSelectProps = Omit<BaseTagDefinitionMultiSelectProps, "entities" | "loading"> & {
  selector?: TagDefinitionSelectorProps
}

export const TagDefinitionMultiSelect = (props: TagDefinitionMultiSelectProps) => {
  const {selector, ...rest} = props;

  const selectTagDefinitions = useMemo(() => {
    return tagDefinitionsSelector()
  }, [])

  const {tagDefinitions, isLoading} = useGetAllTagDefinitionsQuery(undefined, {
    selectFromResult: (result) => ({
      tagDefinitions: selectTagDefinitions(result),
      isLoading: result.isLoading,
    })
  });

  return <BaseTagDefinitionMultiSelect entities={tagDefinitions} loading={isLoading} {...rest} />;
};
